import axios from 'axios';

// Use relative URL for same-domain deployments (like Vercel)
// Use full URL only for cross-domain deployments
const API_URL = process.env.NODE_ENV === 'development' 
  ? '/api' 
  : (process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : '/api');

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

// Get team members
export const getTeamMembers = async () => {
  try {
    const response = await api.get('/team/members');
    return response; // Return the full response object for debugging
  } catch (error) {
    console.error('Error fetching team members:', error);
    throw error.response?.data?.message || 'Failed to fetch team members';
  }
};

// Invite a new team member
export const inviteTeamMember = async (memberData) => {
  try {
    const response = await api.post('/team/invite', memberData);
    return response.data;
  } catch (error) {
    console.error('Error inviting team member:', error);
    throw error.response?.data?.message || 'Failed to invite team member';
  }
};

// Update team member role
export const updateMemberRole = async (userId, userRole) => {
  try {
    const response = await api.put(`/team/members/${userId}/role`, { userRole });
    return response.data;
  } catch (error) {
    console.error('Error updating member role:', error);
    throw error.response?.data?.message || 'Failed to update member role';
  }
};

// Remove team member
export const removeTeamMember = async (userId) => {
  try {
    const response = await api.delete(`/team/members/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error removing team member:', error);
    throw error.response?.data?.message || 'Failed to remove team member';
  }
};

// Accept invitation
export const acceptInvitation = async () => {
  try {
    const response = await api.post('/team/accept-invitation');
    return response.data;
  } catch (error) {
    console.error('Error accepting invitation:', error);
    throw error.response?.data?.message || 'Failed to accept invitation';
  }
};

// Decline invitation
export const declineInvitation = async () => {
  try {
    const response = await api.post('/team/decline-invitation');
    return response.data;
  } catch (error) {
    console.error('Error declining invitation:', error);
    throw error.response?.data?.message || 'Failed to decline invitation';
  }
};

// Get pending invitations (admin only)
export const getPendingInvitations = async () => {
  try {
    const response = await api.get('/team/invitations');
    return response.data;
  } catch (error) {
    console.error('Error fetching pending invitations:', error);
    throw error.response?.data?.message || 'Failed to fetch pending invitations';
  }
};

// Cancel pending invitation (admin only)
export const cancelInvitation = async (invitationId) => {
  try {
    const response = await api.delete(`/team/invitations/${invitationId}`);
    return response.data;
  } catch (error) {
    console.error('Error cancelling invitation:', error);
    throw error.response?.data?.message || 'Failed to cancel invitation';
  }
}; 